// Form8 Types - Program Fee V2
// Flexible metadata-based structure with categories

export interface Section {
  id: string;
  pageComponentId: string;
  componentId?: string;
  type: string;
  variant: string;
  title: string;
  order: number;
  data?: Record<string, any>;
}

export interface FormProps {
  selectedSection: Section;
  onSave: (updatedSection: Section) => void;
  pageId?: string;
  pageComponentId?: string;
  variantDetails?: VariantDetails;
}

export interface VariantDetails {
  id: string;
  name: string;
  description: string;
  componentFields: any[];
  metadataFields?: any[];
  metadata1Fields?: any[];
  categoryMetadataFields?: any[];
  categoryMetadata1Fields?: any[];
  /**
   * Optional per-category configuration fields (e.g. scroll speed/direction),
   * rendered above the category's item table. When omitted, no extra fields show.
   */
  categoryFieldsConfig?: any[];
  /** Persist key for the repeater array. Defaults to "categories". */
  categoriesKey?: string;
  /** Key holding each category's item array. Defaults to "metadata". */
  itemsKey?: string;
  /** Show the fee-style colour pickers per category. Defaults to true. */
  showCategoryColors?: boolean;
  /** UI labels for the repeater (defaults preserve the fee-section wording). */
  repeaterSectionLabel?: string;
  repeaterSectionIcon?: string;
  categoryTitleLabel?: string;
  categoryItemsLabel?: string;
  categoryItemsHint?: string;
  addCategoryLabel?: string;
  categorySingularLabel?: string;
  setAction: any;
  selector: (state: any) => any;
  getMethod?: (id: number) => Promise<any>;
  createMethod?: (data: any) => Promise<any>;
  updateMethod?: (id: number, data: any) => Promise<any>;
  [key: string]: any;
}

export interface MetadataItem {
  id?: string;
  label: string;
  value?: string;
  icon?: string;
  icon_alt?: string;
  description?: string;
  text_color?: string;
  value_text_color?: string;
  value_font_size?: string;
  is_total?: boolean;
  priority?: number;
  status?: boolean;
}

export interface Category {
  id?: string;
  title: string;
  text_color?: string;
  bg_color?: string;
  active_text_color?: string;
  active_bg_color?: string;
  border_color?: string;
  order_index?: number;
  metadata?: MetadataItem[];
  /** Allows config-driven per-category fields (e.g. scroll_frequency) and a custom items key. */
  [key: string]: any;
}

export interface FormState {
  componentFields: Record<string, any>;
  metadata: MetadataItem[];
  metadata_1: MetadataItem[];
  categories: Category[];
  componentFieldErrors: Record<string, boolean>;
  componentFieldMessages: Record<string, string>;
}
